import { render, staticRenderFns } from "./AlterarSenhaForm.vue?vue&type=template&id=2a3c5701"
import script from "./AlterarSenhaForm.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports